
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.997 1.923a1 1 0 00-1.35-.859L1.67 8.056a1 1 0 00-.076 1.858l8.648 3.844 3.844 8.648a1 1 0 001.858-.076l6.993-19.98c.051-.137.071-.283.06-.427zm-4.803 2.469L4.711 9.11l6.067 2.696 7.416-7.415zm-6.001 8.83l7.416-7.416-4.72 13.483-2.696-6.068z","fill":"#04080E"}})])
          )
        }
      }
    